import { createFileRoute } from "@tanstack/react-router";
import { ProjektledelsePage, projektledelseHead } from "@/pages/ProjektledelsePage";

export const Route = createFileRoute("/de/projektleitung")({
  head: () => projektledelseHead("de"),
  component: () => <ProjektledelsePage locale="de" />,
});
